export default __webpack_public_path__ + "static/project-410438ffd458f8522c616aafde64d540.png";